"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Column = exports.ColumnSublayout = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));
var classnames_1 = __importDefault(require("classnames"));
var component_wbr_string_1 = __importDefault(require("@rotaryintl/component-wbr-string"));
require("./column-layout.styles.css");
// const rootClassName = 'rwc-col-layout';
var bem = (0, hook_use_bem_classes_1.default)('rwc-col-layout');
/** A 12-column layout for a page.
 * Direct children should be `Column` elements.
 * @example
 * <ColumnLayout title="My Page" textAlign="center">
 *   <Column span="8">
 *     <RichText />
 *   </Column>
 *   <Column span="4">
 *     <RelatedLinks />
 *   </Column>
 * </ColumnLayout>
 */
var ColumnLayout = function (props) {
  var _a;
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: (0, classnames_1.default)(bem(), props.className)
  }, {
    children: [props.title && (0, jsx_runtime_1.jsx)("div", __assign({
      className: (0, classnames_1.default)(bem('col'), bem('col', "span-12"))
    }, {
      children: (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
        tag: "h1",
        className: (0, classnames_1.default)(bem('title'), (_a = {}, _a[bem('title', 'centered')] = props.titleAlign === 'center', _a))
      }, {
        children: props.title
      }))
    })), props.children]
  }));
};
/** A column of a `ColumnLayout` or `ColumnSublayout` spanning a given subset of the 12-column grid. */
var Column = function (_a) {
  var _b = _a.on,
    breakpoint = _b === void 0 ? 'desktop' : _b,
    props = __rest(_a, ["on"]);
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: (0, classnames_1.default)(bem('col'), bem('col', "span-".concat(props.span, "-").concat(breakpoint)), props.className)
  }, {
    children: props.children
  }));
};
exports.Column = Column;
/** A 12-column grid for sublayouts or components.
 * Can be placed inside of a `Column`.
 *
 * Unlike `ColumnLayout`, `ColumnSublayout` does not have a container and relies on it's parent for a max-width.
 *
 * **Note**: this component introduces a *new* 12-column grid separate from the `ColumnLayout` grid.
 * `Column` elements placed inside should span relative to 12 and not its parent `Column` span.
 * @example
 * <ColumnLayout title="My Page" textAlign="center">
 *   <Column span="8">
 *     <RichText />
 *     <ColumnSublayout>
 *       <Column span="6" on="tablet">Left half</Column>
 *       <Column span="6" on="tablet">Right half</Column>
 *     </ColumnSublayout>
 *   </Column>
 *   <Column span="4">
 *     <RelatedLinks />
 *   </Column>
 * </ColumnLayout>
 */
var ColumnSublayout = function (props) {
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: (0, classnames_1.default)(bem('sublayout'), props.className)
  }, {
    children: props.children
  }));
};
exports.ColumnSublayout = ColumnSublayout;
exports.default = ColumnLayout;